import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

const TITLE_WITH_SUBTITLE_SPACING = sharedStyles.Spacings.EXTRA_EXTRA_SMALL * -1

export const Wrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  position: 'relative',
  marginTop: toPx(sharedStyles.Spacings.MEDIUM),
  marginLeft: toPx(sharedStyles.Spacings.NODE_HORIZONTAL_PADDING),
  marginRight: toPx(sharedStyles.Spacings.NODE_HORIZONTAL_PADDING),
  marginBottom: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
}

export const TitleStyle: React.CSSProperties = {
  ...sharedStyles.subheading,
  lineHeight: 1.4,
  marginTop: toPx(sharedStyles.Spacings.SMALL),
}

export const TitleWithSubTitleStyle: React.CSSProperties = {
  ...TitleStyle,
  lineHeight: 1.4,
  marginTop: toPx(TITLE_WITH_SUBTITLE_SPACING),
}

export const SubTitleStyle: React.CSSProperties = {
  ...sharedStyles.preheader,
  lineHeight: 1.4,
  marginTop: toPx(sharedStyles.Spacings.EXTRA_EXTRA_SMALL * -1),
}

export const MainIconWrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  marginRight: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  marginTop: toPx(sharedStyles.Spacings.EXTRA_EXTRA_SMALL),
  marginBottom: toPx(sharedStyles.Spacings.EXTRA_EXTRA_SMALL),
  flexShrink: 0,
}

export const MainIcon: React.CSSProperties = {
  width: toPx(sharedStyles.IconSizes.LARGE),
  height: toPx(sharedStyles.IconSizes.LARGE),
}

export const AdditionalIcon: React.CSSProperties = {
  position: 'absolute',
  width: toPx(sharedStyles.IconSizes.NORMAL),
  height: toPx(sharedStyles.IconSizes.NORMAL),
  top: toPx((sharedStyles.IconSizes.LARGE * 2) / 3),
  left: toPx((sharedStyles.IconSizes.LARGE * 2) / 3),
}

export const ContentColumn: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
}

export const RightIcon: React.CSSProperties = {
  flexShrink: 0,
  width: toPx(sharedStyles.IconSizes.MEDIUM_LARGE),
  height: toPx(sharedStyles.IconSizes.MEDIUM_LARGE),
  marginTop: toPx(sharedStyles.Spacings.EXTRA_SMALL * -1),
}

export const FloatingRightBlock: React.CSSProperties = {
  position: 'absolute',
  display: 'flex',
  flexDirection: 'row',
  right: 0,
  top: 0,
}

export const RespondentsIconSpacer: React.CSSProperties = {
  width: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  flexShrink: 0,
}
